import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { Card, InputLabel, TextField, withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import swal from '@sweetalert/with-react';
import axios from 'axios';

import axiosInstance, {
  BCC_ADDR_EMAIL,
  emailValidation,
  EVENT_ID,
  F_EMAIL,
  FINDPWD_TEMPLATE,
  focusElementRef,
  WEB_API,
} from '../constatns';
import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';

const styles = (theme) => ({
  cardBox: { width: 740, padding: '40px 100px' },
  form: {
    width: '80%', // Fix IE 11 issue.
    margin: '0 auto',
  },
  inputLabel: {
    color: '#000',
    marginBottom: '5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  formInput: {
    width: '80%',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0',
    },
  },
  loginInfo: {
    textAlign: 'center',
    color: '#999',
    fontSize: '1em',
    lineHeight: 1.7,
    marginTop: 10,
    '& span': {
      color: 'red',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
      '& span': {
        fontSize: '8px',
      },
    },
  },
  submit: {
    fontSize: '1.1em',
    marginTop: theme.spacing(2),
    padding: theme.spacing(2, 0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0, 1),
    },
  },
});

class ForgotPW extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      matches: window.matchMedia('(max-width:600px)').matches,
    };

    this.refEmail = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {}

  handleSubmit(event) {
    const email = this.state.email.replace(/ /gi, '');
    if (email.length < 1) {
      focusElementRef('Please enter your email.', this.refEmail);
      return false;
    } else {
      if (!emailValidation(email)) {
        focusElementRef('Email address seems incorrect (check @ and .’s)', this.refEmail);
      } else {
        axios
          .get(`${WEB_API}/user/checkId?eventId=${EVENT_ID}&userId=${EVENT_ID}_${this.state.email}`, { headers: { Pragma: 'no-cache' } })
          .then((res) => {
            // console.log(res.data);
            if (res.data.exists && res.data.isDel !== 1) {
              let sendParam = {};
              sendParam.userId = EVENT_ID + '_' + this.state.email;
              sendParam.evt = EVENT_ID;
              sendParam.from = F_EMAIL;
              sendParam.templateName = FINDPWD_TEMPLATE;
              sendParam.to = [this.state.email];
              sendParam.bcc = BCC_ADDR_EMAIL;
              axiosInstance
                .post(WEB_API + '/user/findPwd', sendParam)
                .then((d) => {
                  swal(`Your Password has been sent to ${this.state.email}.`);
                })
                .catch((err) => {
                  console.log(err);
                  if (err.response) {
                    swal(err.response.data.message, { icon: 'error' });
                  }
                });
            } else {
              swal('Your account is not available. Please check your ID.');
            }
          });
      }
    }
  }

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <CssBaseline />
        {/* <Topbar MIdx={6} SIdx={7} /> */}
        <Topbar MIdx={6} SIdx={5} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Registration</MainTitle>
            </Grid>
            <Grid item xs={8}>
              <Grid container justifyContent={'center'}>
                <Grid item>
                  <div className={classes.paper}>
                    <Card className={classes.cardBox} variant="outlined" square>
                      <Typography
                        style={{
                          color: this.props.theme.palette.primary.main,
                          fontWeight: 'bold',
                          fontSize: '2.5em',
                        }}
                      >
                        Forgotten your password?
                      </Typography>
                      <Typography variant="subtitle1" className={classes.loginInfo} style={{ textAlign: 'left', paddingBottom: '50px' }}>
                        If you do not remember your password, please enter your ID(Email). Temporary password will be sent out to your
                        e-mail. After you login with the temporary password, you may change to a new password at personal information.
                      </Typography>
                      <div style={{ borderTop: '1px solid #dddddd', paddingTop: '50px' }}>
                        <form className={classes.form} noValidate onSubmit={this.handleSignIn}>
                          <Grid container justifyContent="space-between" alignItems="center">
                            <InputLabel htmlFor="email" className={classes.inputLabel}>
                              ID(E-mail)
                            </InputLabel>
                            <TextField
                              variant="outlined"
                              size="small"
                              required
                              id="email"
                              type="email"
                              name="email"
                              autoFocus
                              onChange={(e) => {
                                this.handleChange('email', e);
                              }}
                              value={this.state.email}
                              className={classes.formInput}
                              inputRef={this.refEmail}
                            />
                          </Grid>

                          <Button
                            fullWidth
                            color="primary"
                            variant="contained"
                            disableElevation
                            className={classes.submit}
                            onClick={this.handleSubmit}
                          >
                            Find Password
                          </Button>
                        </form>
                        {/* <Typography variant="subtitle1" className={classes.loginInfo}>
                          * If you don’t remember your e-mail address, please contact the secretariat.
                        </Typography> */}
                      </div>
                    </Card>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ForgotPW);
